<template>
  <vx-card title="Page SEO">
    <div class="vx-row">
      <div class="vx-col w-full">
        <upload-image
          :src="data.imageUrl"
          @upload-success="data.imageUrl = $event"
          label="Image"
          class="mb-5"
        />
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <vs-input
          label="Title ID"
          v-model="data.titleId"
          class="w-full"
        />
        <vs-textarea label="Description ID" v-model="data.descriptionId" class="mt-5" />
      </div>
      <div class="vx-col w-full sm:w-1/2">
        <vs-input
          label="Title EN"
          v-model="data.titleEn"
          class="w-full"
        />
        <vs-textarea label="Description EN" v-model="data.descriptionEn" class="mt-5" />
      </div>

      <div class="vx-col w-full">
        <vs-button
          icon="save"
          class="mr-6"
          @click="submit"
        >Save</vs-button>
      </div>
    </div>

  </vx-card>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({
        id: '',
        titleid: '',
        titleEn: '',
        descriptionId: '',
        descriptionEn: '',
        imageUrl: '',
        itemList: []
      })
    }
  },
  methods: {
    submit() {
      this.$store.dispatch('page/patch', this.data)
    }
  }
}
</script>
